import { render, staticRenderFns } from "./events_tasks.vue?vue&type=template&id=128815a8&scoped=true"
import script from "./events_tasks.vue?vue&type=script&lang=js"
export * from "./events_tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128815a8",
  null
  
)

export default component.exports